import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const AdminsIcon: React.FC<IconProps> = ({ className = '', size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M9 12l2 2 4-4" />
    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.04 0 2.04.18 2.97.5" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
); 